import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
} from '@app/data/widget-config-templates/basic-cartesian-chart';
export const WhakaaweWaipaRiverNgaruawahia: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nPhosphorus\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nNitrogen\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Total Phosphorus',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Total Nitrogen',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHAKAAWE WHENUA - Land Use Impact: Waipa River / Ngaruawahia bridge',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1191/6',
        analyteIdentifier: 'total-phosphorus',
        valueField: 'avg',
        label: 'Total Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1191/6',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Total Nitogen',
      },
    ],
  },
};

export const WaiWaipaRiverNgaruawahia: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b', '#00b1d8'],
    grid: {
      top: '30%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nLab',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Lab',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling: Waipa River/Ngaruawahia Bridge',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1191/6',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1191/6',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

export const WhakaaweLakeOtamanui: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nPhosphorus\ng/m³',
        position: 'left',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nNitrogen\ng/m³',
        position: 'right',
        offset: 0,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Total Phosphorus',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Total Nitrogen',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHAKAAWE WHENUA - Land Use Impact: Lake Otamanui/Te Otamanui Deepest Point',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_3208/1',
        analyteIdentifier: 'total-phosphorus',
        valueField: 'avg',
        label: 'Total Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_3208/1',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Total Nitogen',
      },
    ],
  },
};

export const TaiaoKaniwhaniwhaStream: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#26312b', '#ee4891', '#8c7ebb'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Water\nlevel\nm',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'left',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'TN\ng/m³',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'P\ng/m³',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water level',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Total Nitrogen',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
  dataConfig: {
    title: 'TAIAO - Ecosystem Health: Kaniwhaniwha Stream/Wright Rd',
    widgetId: 2,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_222/16',
        analyteIdentifier: 'relative-water-level',
        valueField: 'avg',
        label: 'Water level',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_222/16',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_222/16',
        analyteIdentifier: 'Total Nitrogen',
        valueField: 'avg',
        label: 'Total Nitrogen',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_222/16',
        analyteIdentifier: 'dissolved-reactive-phosphorous',
        valueField: 'avg',
        label: 'Dissolved Reactive Phosphorus',
      },
    ],
  },
};

export const WaiWaitetunaRiver: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b', '#00b1d8'],
    grid: {
      top: '30%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nLab',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'ph in Lab',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling: Waitetuna River/Te Uku-Waingaro Rd',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'wrc_1247/2',
        analyteIdentifier: 'ph-in-field',
        valueField: 'avg',
        label: 'PH in Field',
      },
      {
        environmentalDataSourceIdentifier: 'wrc_1247/2',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
    ],
  },
};

// export const PanoniHeiBridge: BasicCartesianChartConfig = {
//   echartsConfig: {
//     ...BasicCartesianChartEchartConfigTemplate,
//     color: ['#00b1d8 ', '#ee4891', '#007093'],
//     grid: {
//       top: '25%',
//       left: '10%',
//       right: '10%',
//       bottom: '6%',
//       containLabel: true,
//     },
//     yAxis: [
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'DO\nmg/m3',
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#00b198',
//           },
//         },
//         axisLabel: {
//           color: '#00b198',
//         },
//       },
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'Turbidity\nNTU',
//         position: 'right',
//         offset: 40,
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#ee4891',
//           },
//         },
//         axisLabel: {
//           color: '#ee4891',
//         },
//       },
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'Temp\n°C',
//         position: 'right',
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#007093',
//           },
//         },
//         axisLabel: {
//           color: '#007093',
//         },
//       },
//     ],
//     series: [
//       {
//         type: 'line',
//         yAxisIndex: 0,
//         name: 'Dissolved oxygen',
//         symbolSize: 13,
//       },
//       {
//         type: 'line',
//         yAxisIndex: 1,
//         name: 'Turbidity',
//         symbolSize: 13,
//       },
//       {
//         type: 'line',
//         yAxisIndex: 2,
//         name: 'Water Temp',
//         symbolSize: 13,
//       },
//     ],
//   },
//   dataConfig: {
//     title: 'PANONI - Land Use Change Over Time: Hei bridge',
//     widgetId: 1,
//     domain: 'wai',
//     dataSources: [
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'dissolved-oxygen-mg-per-litre',
//         valueField: 'avg',
//         label: 'Disolved Oxygen (mg/m3)',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'turbidity',
//         valueField: 'avg',
//         label: 'Turbidity',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'water-temperature',
//         valueField: 'avg',
//         label: 'Water Temp',
//       },
//     ],
//   },
// };

// export const WaiFieldWaterSampling: BasicCartesianChartConfig = {
//   echartsConfig: {
//     ...BasicCartesianChartEchartConfigTemplate,
//     color: ['#007093', '#f26b4b', '#00b1d8', '#26312b', '#00b1d8'],
//     grid: {
//       top: '30%',
//       left: '15%',
//       right: '7%',
//       bottom: '6%',
//       containLabel: true,
//     },
//     yAxis: [
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'Temp\n°C',
//         offset: 40,
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#007093',
//           },
//         },
//         axisLabel: {
//           color: '#007093',
//         },
//       },
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'ph in\nLab',
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#f26b4b',
//           },
//         },
//         axisLabel: {
//           color: '#f26b4b',
//         },
//       },
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'Turbidity\nNTU',
//         position: 'right',
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#f26b4b',
//           },
//         },
//         axisLabel: {
//           color: '#f26b4b',
//         },
//       },
//       {
//         name: 'Black \nDisk\ncm',
//         offset: 80,
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#26312b',
//           },
//         },
//         axisLabel: {
//           color: '#26312b',
//           formatter: (value: any) => Math.round(parseFloat(value)).toString(),
//         },
//         type: 'value',
//         position: 'left',
//         boundaryGap: [0, '100%'],
//         alignTicks: true,
//       },
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'DO\nmg/m3',
//         position: 'right',
//         offset: 40,
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#00b1d8',
//           },
//         },
//         axisLabel: {
//           color: '#00b1d8',
//         },
//       },
//     ],
//     series: [
//       {
//         type: 'line',
//         yAxisIndex: 0,
//         name: 'Water Temp',
//       },
//       {
//         type: 'line',
//         yAxisIndex: 1,
//         name: 'ph in Lab',
//       },
//       {
//         type: 'line',
//         yAxisIndex: 2,
//         name: 'Turbidity',
//       },
//       {
//         type: 'line',
//         yAxisIndex: 3,
//         name: 'Black Disk',
//       },
//       {
//         type: 'line',
//         yAxisIndex: 4,
//         name: 'Dissolved oxygen',
//       },
//     ],
//   },
//   dataConfig: {
//     title: 'WAI - Field Water Sampling: Hei bridge',
//     widgetId: 1,
//     domain: 'wai',
//     dataSources: [
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'water-temperature',
//         valueField: 'avg',
//         label: 'Water Temp',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'ph-in-lab',
//         valueField: 'avg',
//         label: 'PH in Lab',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'turbidity',
//         valueField: 'avg',
//         label: 'Turbidity',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'setchi-disk',
//         valueField: 'avg',
//         label: 'Black Disk',
//       },
//       {
//         environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
//         analyteIdentifier: 'dissolved-oxygen-mg-per-litre',
//         valueField: 'avg',
//         label: 'Dissolved Oxygen',
//       },
//     ],
//   },
// };

// export const WaiRaparapa: BasicCartesianChartConfig = {
//   echartsConfig: {
//     ...BasicCartesianChartEchartConfigTemplate,
//     color: ['#66c39b'],
//     grid: {
//       top: '25%',
//       left: '7%',
//       right: '7%',
//       bottom: '6%',
//       containLabel: true,
//     },
//     yAxis: [
//       {
//         ...BasicCartesianChartAxisTemplate,
//         name: 'Relative Water Level\nm',
//         axisLine: {
//           show: true,
//           lineStyle: {
//             color: '#66c39b',
//           },
//         },
//         axisLabel: {
//           color: '#66c39b',
//         },
//       },
//     ],
//     series: [
//       {
//         type: 'line',
//         yAxisIndex: 0,
//         name: 'Relative Water Level',
//       },
//     ],
//   },
//   dataConfig: {
//     title: 'WAI - Field Water Sampling : Raparapa-a-Hoe',
//     widgetId: 10,
//     domain: 'wai',
//     dataSources: [
//       {
//         environmentalDataSourceIdentifier: 'boprc_raparapahoe_at_above_drop_structure',
//         analyteIdentifier: 'relative-water-level',
//         valueField: 'avg',
//         label: 'Relative Water Level',
//       },
//     ],
//   },
// };
